export default __webpack_public_path__ + "static/media/CodeforCause.7e899e99.png";